export function addKeyPressListener(
  tableId: string,
  searchWithEnterPress: Function
) {
  const tableSearch = document.getElementById(tableId);
  tableSearch?.addEventListener('keydown', (event) => {
    if (event.keyCode !== 13) return;

    event.preventDefault();
    searchWithEnterPress();
  });
}

export function removeKeyPressListener(
  tableId: string,
  searchWithEnterPress: Function
) {
  const tableSearch = document.getElementById(tableId);
  tableSearch?.removeEventListener('keydown', (event) => {
    if (event.keyCode !== 13) return;

    event.preventDefault();
    searchWithEnterPress();
  });
}
